export default function pbxReducer(pbx, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "defaultCountryCallingCode":
      return { ...pbx, [action.type]: Number(action.value.replace("+", "")) };
    case "wallpaper":
    case "screensaver":
      return { ...pbx, [action.type]: action.value ? { id: action.value } : null };
    case "yealinkConfig":
    case "fanvilConfig":
      return { ...pbx, ...action.value };

    default:
      return { ...pbx, [action.type]: action.value };
  }
}
